import { Observable, Subject } from "rxjs";
var WorkflowObservableService = /** @class */ (function () {
    function WorkflowObservableService() {
        this._workflowData$ = new Subject();
    }
    Object.defineProperty(WorkflowObservableService.prototype, "workflowData$", {
        get: function () {
            return this._workflowData$.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    WorkflowObservableService.prototype.setWorkflowData = function (data) {
        this._workflowData$.next(data);
    };
    return WorkflowObservableService;
}());
export { WorkflowObservableService };
